import { WithdrawalStatus } from "@redotech/crdb-enums/returns/withdrawal-status";
import { t } from "@redotech/redo-i18n";

export type WithdrawalTypeValue = "cancelation" | "return";

export function getWithdrawalStatusLabel(status: WithdrawalStatus): string {
  switch (status) {
    case WithdrawalStatus.Pending:
      return t("Pending");
    case WithdrawalStatus.Completed:
      return t("Completed");
    case WithdrawalStatus.RequiresMerchantAction:
      return t("Needs action");
    case WithdrawalStatus.Failed:
      return t("Failed");
    default:
      return status;
  }
}

export function getWithdrawalTypeLabel(type: WithdrawalTypeValue): string {
  switch (type) {
    case "cancelation":
      return t("Cancelation");
    case "return":
      return t("Return");
    default:
      return type;
  }
}
